import TopBar from "@/pages/home/components/TopBar";
import HeroSection from "@/pages/home/components/HeroSection";
import StatsStrip from "@/pages/home/components/StatsStrip";
import TrendingRanking from "@/pages/home/components/TrendingRanking";
import TopicZones from "@/pages/home/components/TopicZones";
import DiscussionBoard from "@/pages/home/components/DiscussionBoard";
import HotComments from "@/pages/home/components/HotComments";
import TeaTalk from "@/pages/home/components/TeaTalk";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <div className="w-full bg-foreground-900">
        <div className="mx-auto flex w-full flex-wrap items-center justify-center gap-x-6 gap-y-1 px-4 py-2.5 text-center text-xs text-background-200 md:px-6 md:text-[13px]">
          <span className="flex items-center gap-1.5">
            <span className="flex h-4 w-4 items-center justify-center text-accent-400">
              <i className="ri-live-line text-sm" />
            </span>
            讨论区正在热聊：把这次事件的完整时间线整理出来了
          </span>
          <a href="#discussion" className="whitespace-nowrap font-medium text-accent-400 hover:text-accent-300">
            马上围观 →
          </a>
        </div>
      </div>

      <TopBar />

      <main className="flex-1 w-full">
        <HeroSection />
        <StatsStrip />
        <TrendingRanking />
        <TopicZones />
        <DiscussionBoard />
        <HotComments />
        <TeaTalk />
      </main>

      <SiteFooter />
    </div>
  );
}